import { atom, useAtomValue } from 'jotai';
import { isEventsCropSwappedAtom, isSelectedVisualisationCropSwappedAtom } from '@/atoms/vis/pitchCropPerspective';
import { pitchCropAtom } from '@/atoms/visualisation';
import { PITCH_CROP } from '@/consts/visualisations';
import { PitchCrop } from '@/types/visualisation';
import { swapPitchCrop } from '@/utils/pitchCrop';

const applySwap = (isSwapped: boolean, crop: PitchCrop): PitchCrop => (isSwapped ? swapPitchCrop(crop) : crop);

const neverSwappedAtom = atom(false);

export const usePitchCrop = (isPreviewVis: boolean, swapUnderAgainst = false): PitchCrop => {
  const pitchCrop = useAtomValue(pitchCropAtom);
  const isSwapped = useAtomValue(swapUnderAgainst ? isEventsCropSwappedAtom : neverSwappedAtom);
  if (isPreviewVis) return PITCH_CROP[0];
  return applySwap(isSwapped, pitchCrop);
};

// the crop of the visualisation on screen, as the user sees it, and the way back to the stored (For frame) crop
export const useSelectedVisualisationCrop = (): {
  visibleCrop: PitchCrop;
  toStoredCrop: (visibleCrop: PitchCrop) => PitchCrop;
} => {
  const storedCrop = useAtomValue(pitchCropAtom);
  const isSwapped = useAtomValue(isSelectedVisualisationCropSwappedAtom);
  return {
    visibleCrop: applySwap(isSwapped, storedCrop),
    toStoredCrop: (visibleCrop: PitchCrop) => applySwap(isSwapped, visibleCrop),
  };
};
